import { ErrorResult } from './error-result';

export interface Updater {
    update(fileData: string, error: ErrorResult): Promise<string>;
}
